import { IWebsiteGallery } from '../../api-response/auth/website-builder';
import { WebsiteBuilderItemBase } from './website-builder-item-base';

export class WebsiteBuilderItemGallery extends WebsiteBuilderItemBase {
    name = 'Gallery';
    navName = 'Gallery';
    navLink = 'gallery';
    isShowInMenu = false;
    isHomePagePart = true;

    type: string = 'grid';
    fileIsOver: boolean = false;
    galleryImages: any[] = [];

    get isDisable(): boolean {
        return !this.galleryImages.length;
    }

    set value(item: IWebsiteGallery) {
        this.isPresent = item.status;
        this.type = item.type;
        this.galleryImages = item.galleryImages.map(({captionText, imageUrl, priority}) => ({captionText, imageUrl, priority}));
        this.priority = item.priority;
    }

    get value(): IWebsiteGallery {
        return {
            type: this.type,
            galleryImages: this.galleryImages,
            status: this.isPresent,
            priority: this.priority
        };
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/items/website-builder-item-gallery.ts